import React, { useState, createContext, useContext } from 'react';
interface ClientContextType {
  clientName: string;
  setClientName: (name: string) => void;
  companyName: string;
  setCompanyName: (name: string) => void;
}
// Updated default values in createContext to reflect new initial state
const ClientContext = createContext<ClientContextType>({
  clientName: 'Gurj Gill',
  setClientName: () => {},
  companyName: 'Soloquest by Gill',
  setCompanyName: () => {}
});
export function ClientProvider({
  children
}: {
  children: React.ReactNode;
}) {
  // Updated initial state values for useState hooks
  const [clientName, setClientName] = useState('Gurj Gill');
  const [companyName, setCompanyName] = useState('Soloquest by Gill');
  return <ClientContext.Provider value={{
    clientName,
    setClientName,
    companyName,
    setCompanyName
  }} data-id="element-36">
      {children}
    </ClientContext.Provider>;
}
export function useClient() {
  return useContext(ClientContext);
}